// Grounded in the updated CV and original portfolio. Covers are conceptual illustrations.
export const profile = {
  name: "Priyajan Swongamikha",
  email: "aswongamikha@gmail.com",
  github: "https://github.com/Priyajan-collab",
  linkedin: "https://www.linkedin.com/in/priyajan-swongamikha-907a06229/",
  youtube: "https://www.youtube.com/channel/UCIdlPw2f3mBgIIyc4bF3v-g",
  afterimage: "https://www.youtube.com/@Afterimage_Channel",
  devlog: "https://www.youtube.com/@LastStandAgainstBrainRot",
  cv: "/assets/Priyajan-Swongamikha-CV.pdf",
};
export const projects = [
  {
    id: "krishi",
    number: "01",
    title: "Krishi Sathi",
    category: "ai",
    discipline: "Applied ML · Full-stack",
    note: "Hackathon winner",
    cover: "krishi",
    description:
      "Turning soil data, plant images, and machine learning into a helping hand for farmers.",
    tech: ["Next.js", "Python", "YOLO", "Random Forest"],
    intro:
      "An agricultural assistance platform that brings several machine-learning tools into one usable web experience.",
    challenge:
      "A useful model needs a way to reach the person making a decision. For Krishi Sathi, that meant connecting agricultural data, model inference, and an approachable interface.",
    contribution:
      "Built authentication and data visualization, integrated plant disease detection with fine-tuned YOLO, and used Random Forest for crop recommendations. Added location-based soil-data retrieval and a RAG-based Legal Sathi for document analysis.",
    reflection:
      "This project brings together the reason I learned full-stack development in the first place: making the models I build accessible to people.",
    stack:
      "Next.js, Node.js, NextAuth, MongoDB, TypeScript, Pinecone, Groq API, Leaflet, scikit-learn, onnxruntime-node.",
    outcome: "Won a college hackathon in my fourth semester.",
  },
  {
    id: "ismh",
    number: "02",
    title: "ISMH",
    category: "systems",
    discipline: "Systems · Retrieval-augmented AI",
    note: "Personal project",
    cover: "ismh",
    description:
      "Business conversations, connected. A multi-tenant messaging system with AI and a human handover.",
    tech: ["NestJS", "PostgreSQL", "pgvector", "FastAPI"],
    intro:
      "A multi-tenant business messaging SaaS connecting WhatsApp, Instagram, and Messenger with a retrieval-augmented generation pipeline.",
    challenge:
      "Connecting channels is only part of the problem. Conversations need tenant isolation, reliable history, secure credentials, and a clear path for a person to take over from AI.",
    contribution:
      "Built a RAG pipeline using sentence-transformers embeddings and Groq-hosted generation, with human-agent takeover. Designed tenant data isolation, an append-only message log, AES-256-GCM token encryption, and document ingestion through extraction, validation, chunking, and embedding.",
    reflection:
      "The interesting work lives between the model and the product: who can see which message, how context is retrieved, and when control should return to a human.",
    stack:
      "NestJS, React, Vite, TanStack Router/Query, Python/FastAPI, PostgreSQL with pgvector, Redis, MinIO, Prisma.",
    outcome:
      "A personal exploration of applied AI and the systems that support it.",
  },
  {
    id: "flood",
    number: "03",
    title: "Reading the flood",
    category: "ai",
    discipline: "Computer vision · Remote sensing",
    note: "Research project",
    cover: "flood",
    description:
      "Exploring how a neural network can read satellite imagery and identify flooded ground.",
    tech: ["Python", "U-Net", "Image segmentation"],
    intro:
      "Flood detection using satellite imagery and a U-Net-based deep-learning approach.",
    challenge:
      "Satellite images contain complex spatial patterns. Flood mapping calls for segmentation: identifying relevant regions within an image rather than assigning one label to the whole scene.",
    contribution:
      "Worked on a U-Net-based approach to flood detection, exploring segmentation-oriented analysis of satellite imagery.",
    reflection:
      "It is an application of computer vision that connects my interest in mathematical models with a tangible problem in the world around me.",
    stack:
      "Python, deep learning, U-Net, satellite imagery, image segmentation.",
    outcome: "A research project in geospatial computer vision.",
  },
  {
    id: "manim",
    number: "04",
    title: "Afterimage",
    category: "math",
    discipline: "Mathematics · Visual storytelling",
    note: "Pipeline experiment",
    cover: "manim",
    description:
      "Testing a text-to-video pipeline through the maths content I’ve always wanted to create.",
    tech: ["Python", "Manim", "Narration", "Video pipelines"],
    intro:
      "Afterimage is my test channel for a text-to-video pipeline, born from a long-standing wish to make mathematical content without production becoming the barrier.",
    challenge:
      "I wanted to share mathematics, but scripting, editing, and animating every video was tedious. The question became: can a pipeline make that work manageable while still producing something worth watching?",
    contribution:
      "Developed visual lessons and a rendering workflow around Manim, narration alignment, captions, and video composition. The project assets explore topics including integrals, Cantor’s infinities, and linear algebra.",
    reflection:
      "The name came after trekking: a remarkable view cannot be fully captured by a camera or remembered from one look. The feeling that remains is the afterimage. That idea sits behind the channel as much as the mathematics does.",
    stack:
      "Python, Manim, mathematical visualization, narration and caption timing, video composition.",
    outcome:
      "An ongoing experiment in whether my text-to-video pipeline has value.",
    link: profile.afterimage,
    linkLabel: "Explore Afterimage",
  },
];
export const experience = [
  {
    period: "15 JAN — 22 JUL 2026",
    company: "Nishwet Box",
    role: "AI/ML Engineer",
    description:
      "Bringing applied AI into production: RAG pipelines, PaddleOCR menu digitization, and full-stack development for iFusion CRM.",
    detail: "Fastify · tRPC · Prisma · PostgreSQL · React · TanStack",
    learning: "Learning how intelligence fits into a dependable product.",
  },
  {
    period: "2025 — 2026",
    company: "Asteroid Studio",
    role: "Full Stack Intern → Junior",
    description:
      "Built fintech and billing workflows: bank reconciliation, multi-currency accounting, transactional invoices, and traceable PDF generation.",
    detail: "Next.js · TypeScript · Node.js · GraphQL · SQL",
    learning: "Learning that correctness is part of the experience.",
  },
  {
    period: "2022",
    company: "Team Nepica",
    role: "IoT Engineer & Python Developer",
    description:
      "Short-term engineering work connecting Python and IoT. An early step from writing programs to making things work beyond the screen.",
    detail: "Python · IoT · Engineering",
    learning: "Learning by building, testing, and trying again.",
  },
];
export const toolkit = [
  {
    title: "Build the experience",
    text: "React, Next.js, TypeScript, TanStack, Tailwind CSS, Radix UI",
  },
  {
    title: "Design the system",
    text: "Node.js, NestJS, Fastify, Go, tRPC, GraphQL, REST APIs",
  },
  {
    title: "Work with intelligence",
    text: "Python, RAG, PaddleOCR, scikit-learn, NumPy, pandas, basic PyTorch",
  },
  {
    title: "Give it a foundation",
    text: "PostgreSQL, pgvector, Redis, MongoDB, Prisma, Git, Linux",
  },
];
export const archive = [
  {
    name: "purpleGen / the early animations",
    type: "The starting point · Python & Manim",
    link: profile.youtube,
  },
  {
    name: "Face detection",
    type: "Computer vision",
    link: "https://github.com/Priyajan-collab/Face_detection",
  },
  {
    name: "OptimizeLfy",
    type: "C · GTK · Desktop",
    detail:
      "A task management application with authentication and isolated per-user databases.",
  },
  {
    name: "Electronic device simulation",
    type: "C++ · Circuit logic",
    detail:
      "An electronic circuit simulation application exploring core circuit logic and user interaction.",
  },
  {
    name: "ML from first principles",
    type: "Python · NumPy",
    detail:
      "Linear regression, logistic regression, and decision trees implemented from scratch.",
  },
];
